// 规则格式示例：
// {
//             // 一般规则
//             normal: {
//                 // 指定该区域可选字段类型
//                 dataType: {
//                     value: ['2'],
//                     message: '只能选择度量'
//                 },
//                 // 指定该区域数据数量范围，-1代表不限制
//                 range: {
//                     value: [1, -1],
//                     message: '度量数量必须 >= 1'
//                 },
//                 // 是否允许重复选择字段
//                 fieldRepeat: {
//                     value: false,
//                     message: '字段不允许重复'
//                 },
//                 // 禁用的字段 (指定字段原名)
//                 disabledField: {
//                     value: [],
//                     message: 'xx已选用该字段'
//                 }
//             },
//             // 关联规则，用于联动其他组
//             related: [
//                 {
//                     // 关联的组的key
//                     relateTarget: 'legend',
//                     // 触发条件 'true'一直触发，'false'一直不触发，dataRe => 关联的组的已选字段列表， data => 当前组的已选字段
//                     trigger: 'dataRe.length > 0', // 即当legend的已选择字段大于0时触发
//                     // 行为模式 'replace' 替换，'merge' 合并
//                     mode: 'replace',
//                     // 关联的规则(会根据mode替换当前组的原有规则) 同 DataAreaGroup 的 rules 属性，特殊参数：'data' 当前组的已选字段，dataRe 关联的组的已选字段列表
//                     relateRules: {
//                         range: {
//                             value: [1, 1],
//                             message: '选择图例时，度量只能选择一个'
//                         },
//                     }
//                 }
//             ]
//         },


let dataAreaRules = [
    {
        // 匹配的chart类型
        charts: ['bar', 'line', 'area'],
        // 规则
        rules: {
            yAxis: {
                // 一般规则
                normal: {
                    // 指定该区域可选字段类型
                    dataType: {
                        value: ['2'],
                        message: '只能选择度量'
                    },
                    // 指定该区域数据数量范围，-1代表不限制
                    range: {
                        value: [1, -1],
                        message: '度量数量必须 >= 1'
                    },
                    // 是否允许重复选择字段
                    fieldRepeat: {
                        value: true,
                        message: '字段不允许重复'
                    },
                    // 禁用的字段 (指定字段原名)
                    disabledField: {
                        value: [],
                        message: 'xx已选用该字段'
                    }
                },
                // 关联规则，用于联动其他组
                related: [
                    {
                        // 关联的组的key
                        relateTarget: 'legend',
                        // 触发条件 'true'一直触发，'false'一直不触发，dataRe => 关联的组的已选字段列表， data => 当前组的已选字段
                        trigger: 'dataRe.length > 0',
                        // 行为模式 'replace' 替换，'merge' 合并
                        mode: 'replace',
                        // 关联的规则(会根据mode替换当前组的原有规则) 同 DataAreaGroup 的 rules 属性，特殊参数：'data' 当前组的已选字段，dataRe 关联的组的已选字段列表
                        relateRules: {
                            range: {
                                value: [1, 1],
                                message: '选择图例时，度量只能选择一个'
                            },
                        }
                    }
                ]
            },
            xAxis: {
                normal: {
                    dataType: {
                        value: ['1'],
                        message: '只能选择维度'
                    },
                    range: {
                        value: [1, 10],
                        message: '维度数量必须 >= 1 且 < 10'
                    },
                    fieldRepeat: {
                        value: false,
                        message: '字段不允许重复'
                    },
                    disabledField: {
                        value: [],
                        message: 'xx已选用该字段'
                    }
                },
                related: [
                    {
                        relateTarget: 'legend',
                        trigger: 'dataRe.length > 0',
                        mode: 'merge',
                        relateRules: {
                            disabledField: {
                                value: 'dataRe',
                                message: '图列不可和维度重复'
                            },
                        }
                    },
                ]
            },
            legend: {
                normal: {
                    dataType: {
                        value: ['1'],
                        message: '只能选择维度'
                    },
                    range: {
                        value: [0, 1],
                        message: '图例只能选择一个'
                    },
                    fieldRepeat: {
                        value: false,
                        message: '字段不允许重复'
                    },
                    disabledField: {
                        value: [],
                        message: 'xx已选用该字段'
                    }
                },
                related: [
                    {
                        relateTarget: 'yAxis',
                        trigger: 'dataRe.length > 1',
                        mode: 'replace',
                        relateRules: {
                            range: {
                                value: [0, 0],
                                message: '选择图例时，度量不能选择1个以上'
                            },
                        }
                    },
                    {
                        relateTarget: 'xAxis',
                        trigger: 'dataRe.length > 0',
                        mode: 'merge',
                        relateRules: {
                            disabledField: {
                                value: 'dataRe',
                                message: '图列不可和维度重复'
                            },
                        }
                    },
                ]
            },
        },
        // 启用的组
        usedGroups: ['xAxis', 'yAxis','legend', 'filter']
    },
    {
        // 匹配的chart类型
        charts: ['mixed'],
        // 规则
        rules: {
            yAxisBLA: {
                // 一般规则
                normal: {
                    // 指定该区域可选字段类型
                    dataType: {
                        value: ['2'],
                        message: '只能选择度量'
                    },
                    // 指定该区域数据数量范围，-1代表不限制
                    range: {
                        value: [1, -1],
                        message: '度量数量必须 >= 1'
                    },
                    // 是否允许重复选择字段
                    fieldRepeat: {
                        value: true,
                        message: '字段不允许重复'
                    },
                    // 禁用的字段 (指定字段原名)
                    disabledField: {
                        value: [],
                        message: 'xx已选用该字段'
                    }
                },
                // 关联规则，用于联动其他组
                related: []
            },
            xAxis: {
                normal: {
                    dataType: {
                        value: ['1'],
                        message: '只能选择维度'
                    },
                    range: {
                        value: [1, 10],
                        message: '维度数量必须 >= 1 且 < 10'
                    },
                    fieldRepeat: {
                        value: false,
                        message: '字段不允许重复'
                    },
                    disabledField: {
                        value: [],
                        message: 'xx已选用该字段'
                    }
                },
                related: []
            }
        },
        // 启用的组
        usedGroups: ['xAxis', 'yAxisBLA', 'filter' ]
    },
    {
        // 匹配的chart类型
        charts: ["pie"],
        // 规则
        rules: {
            angle: {
                // 一般规则
                normal: {
                    // 指定该区域可选字段类型
                    dataType: {
                        value: ["2"],
                        message: "只能选择度量"
                    },
                    // 指定该区域数据数量范围，-1代表不限制
                    range: {
                        value: [0, 1],
                        message: "度量只能选择一个"
                    },
                    // 是否允许重复选择字段
                    fieldRepeat: {
                        value: true,
                        message: "字段不允许重复"
                    },
                    // 禁用的字段 (指定字段原名)
                    disabledField: {
                        value: [],
                        message: "xx已选用该字段"
                    }
                },
                // 关联规则，用于联动其他组
                related: []
            },
            textLabel: {
                normal: {
                    dataType: {
                        value: ["1"],
                        message: "只能选择维度"
                    },
                    range: {
                        value: [0, 1],
                        message: "维度只能选择一个"
                    },
                    fieldRepeat: {
                        value: false,
                        message: "字段不允许重复"
                    },
                    disabledField: {
                        value: [],
                        message: "xx已选用该字段"
                    }
                },
                related: []
            }
        },
        // 启用的组
        usedGroups: ["textLabel", "angle", "filter"]
  }
];
export default dataAreaRules;
